import { Link } from "react-router-dom";
import { Play, Moon } from "lucide-react";
import { thumb } from "../lib/api";
import { LangBadge } from "./Flags";

export const SongCard = ({ song, index = 0 }) => (
  <Link to={`/comptines/${song.slug}`} data-testid={`song-card-${song.slug}`}
    className="cloud-card group block overflow-hidden !rounded-[36px] anim-pop transition-transform duration-200 hover:-translate-y-1 active:translate-y-1"
    style={{ animationDelay: `${index * 70}ms` }}>
    <div className="relative aspect-video overflow-hidden rounded-t-[32px]">
      <img src={thumb(song.youtube_id)} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
      <div className="absolute left-3 top-3 flex gap-2">
        <LangBadge lang={song.language} testId={`song-lang-badge-${song.slug}`} />
        {song.calm && (
          <span className="inline-flex items-center gap-1 rounded-full bg-[#1E2A5A]/85 px-2.5 py-1 text-xs font-bold text-white">
            <Moon className="w-3.5 h-3.5" /> Calme
          </span>
        )}
      </div>
      <span className="absolute bottom-3 right-3 grid h-14 w-14 place-items-center rounded-full bg-[#FFD21F] border-4 border-white shadow-lg">
        <Play className="w-6 h-6 fill-[#1E2A5A] text-[#1E2A5A] ml-1" />
      </span>
    </div>
    <h3 className="px-5 py-4 text-xl font-bold leading-tight">{song.title}</h3>
  </Link>
);
